document.addEventListener('DOMContentLoaded', async function () {
  try {
    await window.loadSwiper();
  } catch (error) {
    console.error('[swiper-card] Unable to load Swiper.', error);
    return;
  }
    (function () {

        // 初始化 Swiper 组件
        function initSwiper() {

            new Swiper('.swiper-card-banner-list2', {
                spaceBetween: window.innerWidth < 768 ? 0 : slideSpace,
                slidesPerView: slide_count, 
                // slideToClickedSlide: true,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    768: {
                        spaceBetween: slideSpace,
                        slidesPerView: slide_count
                    },
                    500: {
                        spaceBetween: slideSpace,
                        slidesPerView: 2
                    },
                    0: {
                        spaceBetween: 0,
                        slidesPerView: 1 
                    },
                }
            });
        }

        // 执行 Swiper 初始化
        initSwiper();
    })();
});
